import NavBar from "../../general/NavBar";
import { Player } from "@lottiefiles/react-lottie-player";
import { requireAsset } from "../../../utils/asset";

const SurveyComplete = ({ surveyData, onClick }) => {
  const text = surveyData.survey_completion_text;

  return (
    <div className="z-[51] fixed top-0 left-0 flex flex-col h-screen w-screen bg-background">
      <NavBar />
      <div className="flex flex-col grow justify-center content-center max-w-md mx-auto">
        <h1 className="text-4xl text-center font-MS font-extrabold">All done!</h1>
        <Player src={requireAsset("success.json")} className="w-full h-full max-w-60 max-h-60" keepLastFrame autoplay />
        <div className="text-center">{ text }</div>
      </div>
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 flex flex-row">
        <button
          onClick={() => onClick()}
          className="p-5 w-fit bg-accent min-w-[120px] text-center text-lg font-semibold shadow-default rounded-lg cursor-pointer hover:scale-110 duration-200"
        >
          Go To Dashboard
        </button>
      </div>
    </div>
  );
};

export default SurveyComplete;
